import {Injectable} from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class PathService {

    private _hostServerBackOffice;
    private _hostServerSecurity;

    get hostServerBackOffice() {
        return this._hostServerBackOffice;
    }

    set hostServerBackOffice(value) {
        this._hostServerBackOffice = value;
    }

    get hostServerSecurity() {
        return this._hostServerSecurity;
    }

    set hostServerSecurity(value) {
        this._hostServerSecurity = value;
    }
}